// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__4oj6F","buttons":"Home_buttons__aNpS7"};